/* eslint-disable */
import React from 'react';
import Stack from '@mui/material/Stack';
import {useTranslation} from "react-i18next";
import {Icon} from '@iconify/react';
import cloudUploadOutline from '@iconify/icons-eva/cloud-upload-outline';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import {IconButton, Tooltip} from "@mui/material";
import {styled} from "@mui/material/styles";
import {grey} from '@mui/material/colors';

const IconUploadStyle = styled(Icon, {
    shouldForwardProp: (prop) => prop !== "disableUpload"
})<{ disableUpload?: boolean; }>(({theme, disableUpload}) => ({
    color: (disableUpload) ? grey['400'] : theme.palette.primary.main,
    width: theme.spacing(3)
}));

const IconResetStyle = styled(Icon, {
    shouldForwardProp: (prop) => prop !== "disableReset"
})<{ disableReset?: boolean }>(({theme, disableReset}) => ({
    color: (disableReset) ? grey['400'] : theme.palette.primary.main,
    width: theme.spacing(3)
}));

const StackStyle = styled(Stack)(() => ({
    width: '100%',
    margin: 0
}));

const ButtonsPond = ({handleUpload, clearFileList, hasUploadButton, hasResetButton, disableUpload, disableReset}: any): any => {
    const {t} = useTranslation()

    return (
        <StackStyle direction="row" spacing={1} alignItems="center">
            {
                hasUploadButton &&
                <Tooltip title={t('common.upload')}>
                    <IconButton edge="end" onClick={handleUpload} disabled={disableUpload} component={disableUpload ? "div" : undefined}>
                        <IconUploadStyle icon={cloudUploadOutline} disableUpload={disableUpload}/>
                    </IconButton>
                </Tooltip>
            }

            {
                hasResetButton &&
                <Tooltip title={t('common.clear')}>
                    <IconButton edge="end" onClick={clearFileList} disabled={disableReset} component={disableReset ? "div" : undefined}>
                        <IconResetStyle icon={trash2Outline} disableReset={disableReset}/>
                    </IconButton>
                </Tooltip>
            }
        </StackStyle>
    );
}

export default ButtonsPond;
